import { MutableRefObject, type RefCallback } from 'react';

import { useImmutableCallback } from './use-immutable-callback';

export function useCombineRefs<T>(
  refs: (RefCallback<T> | MutableRefObject<T | null> | null | undefined)[]
): RefCallback<T> {
  return useImmutableCallback((value) => {
    refs.forEach((ref) => {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref) {
        ref.current = value;
      }
    });
  });
}
